import React from 'react'
import './OurGrowingNationalFootprint.component.scss'

const OurGrowingNationalFootprint = () => {
  return (
    <section className='our-growing-national-footprint'>
      <div className='our-growing-national-footprint__inner'>
        <h2 className='our-growing-national-footprint__title'>Our Growing National Footprint</h2>
        <p className='our-growing-national-footprint__subtitle'>
          With corporate leadership in Florida and growing franchise locations across multiple states, USA Benefits
          Group delivers national strength with local expertise.
        </p>
      </div>
    </section>
  )
}

export default OurGrowingNationalFootprint
